import { ENV } from "application/constants/app-constants";
import { split, replace, join, drop } from "ramda";

export default function getInitialUrl() {
  if (ENV === "local") {
    return "";
  }

  const splittedUrl = split(`/inetgeco${ENV === "preint" ? "-preint" : ""}`, window.location.href);
  const cleanHttps = replace("https://", "", splittedUrl[0]);
  const initUrl = split("/", cleanHttps).length > 1 ? `/${join("/", drop(1, split("/", cleanHttps)))}` : "";
  return initUrl;
}
